/**
 * Constants
 * @object
 */

const config = {};

const actions = {
  WINDOW_RESIZE: 'WINDOW_RESIZE',
  OPEN_MAIN_MENU: 'OPEN_MAIN_MENU',
  CLOSE_MAIN_MENU: 'CLOSE_MAIN_MENU',
  GO_TO_SLIDE: 'GO_TO_SLIDE',
  SLIDE_CHANGED: 'SLIDE_CHANGED',
  GO_TO_LANDING_CONTENT: 'GO_TO_LANDING_CONTENT',
  GO_TO_MAIN_CONTENT: 'GO_TO_MAIN_CONTENT',
  SHOW_LARGE_LANDING: 'SHOW_LARGE_LANDING',
  REMOVE_LARGE_LANDING: 'REMOVE_LARGE_LANDING',
  ADVANCE_SLIDE: 'ADVANCE_SLIDE',
  REVERSE_SLIDE: 'REVERSE_SLIDE',
  SECTION_TRANSITION_COMPLETE: 'SECTION_TRANSITION_COMPLETE',
  SECTION_TRANSITION_IN_PROGRESS: 'SECTION_TRANSITION_IN_PROGRESS',
};

const constants = Object.assign(config, actions);

export default constants;



/** WEBPACK FOOTER **
 ** ./assets/js/src/constants/AppConstants.js
 **/